import axios from "axios";
import {
    POST_CUSTOMER,
    PUT_CUSTOMER,
    GET_CONTRACTS,
    GET_TRANSPORTS,
    GET_CUSTOMER,
    GET_CUSTOMER_DOMAIN,//To be accorped with /selòector domain
    GET_TRANSPORTERS_DOMAIN,//To be accorped with /selòector domain
    GET_CUSTOMERS,
    POST_CONTRACT,
    PUT_CONTRACT_INFO,
    POST_TRANSPORT,
    GET_CONTRACT,
    PUT_TRANSPORT_INFO,
    GET_TRANSPORT,
    GET_DOCUMENT,
    PUT_DOCUMENT,
    EntityType,
    DELETE_ENTITY,
    DOWNLOAD_INFO,
    DOWNLOAD_DOCUMENT,
    DocumentType,
    GET_DRIVERS,
    POST_DRIVER,
    GET_DRIVER,
    PUT_DRIVER_INFO,
    GET_VEHICLES,
    GET_VEHICLE,
    BadgeStatus,
    DELETE_TRANSPORTER,
    CHANGE_STATUS,
    DELETE_DELEGATION,
    SELECTOR,
    ADD_DELEGATION,
    POST_VEHICLE,
    PUT_VEHICLE_INFO,
    ENABLE_DISABLE_DELEGATION,
    GET_DELEGATING_CUSTOMERS,
    GET_DELEGATED_CUSTOMERS,
    CUSTOMER_DELEGATION,
    DELETE_CUSTOMER_DELEGATION,
    GET_DELEGATION_BY_ID,
    GET_CLIENT_CONTRACTS,
    POST_CUSTOMER_ISCC_DOCUMENT,
    DELETE_CUSTOMER_ISCC_DOCUMENT,
    GET_CUSTOMER_ISCC_DOCUMENT_BY_ID,
    PUT_CUSTOMER_ISCC_DOCUMENT_STATUS
} from "shared/constants";
import { IContract, ICustomer, ITransport, IDocument, IDriver, IDelegation, IVehicle, ICustomerDelegation, ICustomerIscc } from "dataModels/contract";

//const HOST = process.env.REACT_APP_HOST_CONTRACTS;
const HOST = window&&window._env_?window._env_.REACT_APP_HOST_CONTRACTS:process.env.REACT_APP_HOST_CONTRACTS;
const MODULE: string = "/contracts";

/** New Customer creation */
export const postNewCustomer = (postData: ICustomer) => {
    return axios.post(HOST + MODULE + POST_CUSTOMER, postData)
        .then(response => {
            return response;
        })
}

/** Edit customer */
export const putCustomer = (customerData: ICustomer) => {
    return axios.put(HOST + MODULE + PUT_CUSTOMER, customerData)
        .then(response => {
            return response;
        })
}

/** Load contract list */
export const getContracts = (requestCtx:string,activeOnly?:boolean) => {
    let queryStr = '?requestContext='+requestCtx
    if(activeOnly){
        queryStr += '&activeOnly='+activeOnly.toString()
    }
    return axios.get(HOST + MODULE + GET_CONTRACTS+queryStr)
}

export const getTransports = () => {
    return axios.get(HOST + MODULE + GET_TRANSPORTS)
}

/** Load single contract data */
export const getContract = (contractId: string) => {
    return axios.get(HOST + MODULE + GET_CONTRACT, { params: { contractId: contractId } });
}

/** Get customer data by contractId or by business id*/
export const getCustomerByContractId = (contractId: string) => {
    return axios.get(HOST + MODULE + GET_CUSTOMER, { params: { contractId: contractId, businessId: '' } });
};
export const getCustomerByBusinessId = (businessId: string) => {
    return axios.get(HOST + MODULE + GET_CUSTOMER, { params: { contractId: '', businessId: businessId } });
};

// -----------------TO BE MODIFIED WITH /selector and entityType param
export const getCustomerDomain = (type:string,activeonly?:string) => {
    let queryString = '?requestContext='+type;
    if(activeonly){
        queryString += '&activeOnly='+activeonly.toString()
    }
    return axios.get(HOST + MODULE + GET_CUSTOMER_DOMAIN +queryString)
        .then(response => {
            return response.data;
        });
}
export const getTransporterDomain = (entityType:EntityType) =>{
    return axios.get(HOST + MODULE + GET_TRANSPORTERS_DOMAIN, {params:{entityType:entityType}})
        .then(response => {
            return response.data;
        });
}
//---------------------------

export const getCustomers = () => {
    return axios.get(HOST + MODULE + GET_CUSTOMERS)
        .then(response => {
            return response.data;
        });
}




/** New contract creation */
export const postContract = (postData: IContract) => {
    return axios.post(HOST + MODULE + POST_CONTRACT, postData)
        .then(response => {
            return response;
        })
}

/** Edit contract info */
export const putContractInfo = (contractData: IContract) => {
    return axios.put(HOST + MODULE + PUT_CONTRACT_INFO, contractData)
        .then(response => {
            return response;
        })
}




export const postTransport = (postData: ITransport) => {
    return axios.post(HOST + MODULE + POST_TRANSPORT, postData)
        .then(response => {
            return response;
        })
}

/** Load single transporter data */
export const getTransport = (transporterId: string) => {
    return axios.get(HOST + MODULE + GET_TRANSPORT, { params: { transporterId: transporterId } });
}

/* Edit transporter info */
export const putTransport = (transportData: ITransport) => {
    return axios.put(HOST + MODULE + PUT_TRANSPORT_INFO, transportData)
        .then(response => {
            return response;
        })
}

/** Get the document to edit for any entity */
export const getDocument = (entityId: string, entityType: string, documentType: string) => {
    return axios.get(HOST + MODULE + GET_DOCUMENT, { params: { entityId: entityId, entityType: entityType, documentType: documentType } })
        .then(response => {
            return response.data;
        })
}
/** Update document (Contract, Transport) */
export const putDocument = (entityId: string, entityType: EntityType, document: IDocument) => {
    return axios.put(HOST + MODULE + PUT_DOCUMENT, document, { params: { entityId: entityId, entityType: entityType } })
        .then(response => {
            return response;
        })
}

export const deleteEntity = (entityId: string, entityType: EntityType,) => {
    return axios.delete(HOST + MODULE + DELETE_ENTITY, { params: { entityId: entityId, entityType: entityType } });
}

// New driver
export const postDriver = (postData: IDriver) => {
    return axios.post(HOST + MODULE + POST_DRIVER, postData)
        .then(response => {
            return response;
        })
}

{/** Drivers list */}
export const getDrivers = (driverStatus:BadgeStatus) => {
    return axios.get(HOST + MODULE + GET_DRIVERS, {params:{driverStatus :driverStatus }})
        .then(response => {
            return response.data;
        });
}

{/** Load single driver */}
export const getDriver = (driverId:string)=>{
    return axios.get(HOST + MODULE + GET_DRIVER, { params: { driverId: driverId } });
}

/* Edit driver info */
export const putDriver = (driverData: IDriver) => {
    return axios.put(HOST + MODULE + PUT_DRIVER_INFO, driverData)
        .then(response => {
            return response;
        })
}


{/** Vehicles list */}
export const getVehicles = (vehicleStatus:BadgeStatus) => {
    return axios.get(HOST + MODULE + GET_VEHICLES, {params:{vehicleStatus :vehicleStatus }})
        .then(response => {
            return response.data;
        });
}

{/** Load single vehicle */}
export const getVehicle = (vehicleId:string)=>{
    return axios.get(HOST + MODULE + GET_VEHICLE, { params: { vehicleId: vehicleId } });
}

/** New vehicle creation */
export const postVehicle = (postData: IVehicle) => {
    return axios.post(HOST + MODULE + POST_VEHICLE, postData)
        .then(response => {
            return response;
        })
}
/* Edit vehicle info */
export const putVehicle = (vehicleData: IVehicle) => {
    return axios.put(HOST + MODULE + PUT_VEHICLE_INFO, vehicleData)
        .then(response => {
            return response;
        })
}


/** Business, Contract, transporter, driver info pdf download  */
export const downloadInfo = (entityId: string, entityType: EntityType) => {
    return axios.get(HOST + MODULE + DOWNLOAD_INFO, { params: { entityId: entityId, entityType: entityType }, responseType: "blob" })
}
/** Contract, drivers and transporter document pdf download  */
export const downloadDocument = (entityId: string, entityType: EntityType, documentType: DocumentType) => {
    return axios.get(HOST + MODULE + DOWNLOAD_DOCUMENT, { params: { entityId: entityId, entityType: entityType, documentType: documentType }, responseType: "blob" });
}

export const deleteTransport = (transporterId:string)=>{
    return axios.delete(HOST+MODULE+DELETE_TRANSPORTER, {params:{transporterId:transporterId}});
}

export const changeStatus = (entityId:string,entityType:EntityType,newStatus:BadgeStatus,message:string)=>{
    return axios.put(HOST+MODULE+CHANGE_STATUS, null, {params:{entityId:entityId,entityType:entityType,newStatus:newStatus,message:message}})
}

export const deleteDelegationAPI = (entityId:string,entityType:EntityType)=>{
    return axios.delete(HOST+MODULE+DELETE_DELEGATION,{params:{entityId:entityId,entityType:entityType}})
    .then(response=>{
        return response.data;
    });
}

export const selectorAPI = (entityType:EntityType,entityId?:string) => {
    let _entityId = entityId?entityId:'';
    return axios.get(HOST+MODULE+SELECTOR,{params:{entityId:entityId,entityType:entityType}})
    .then(response=>{
        return response.data;
    });
}

export const addDelegation = (delegation:IDelegation) => {
    return axios.post(HOST+MODULE+ADD_DELEGATION,delegation)
    .then(response=>{
        return response.data;
    });
}

export const enableDisableDelegationAPI = (transporterId:string,delegationId:string,newStatus:boolean)=>{
    return axios.put(HOST+MODULE+ENABLE_DISABLE_DELEGATION, null, {params:{transporterId:transporterId,delegationId:delegationId,newStatus:newStatus}})
}

export const getDelgatingCustomers = () => {
    return axios.get(HOST+MODULE+GET_DELEGATING_CUSTOMERS)
    .then(response=>{
        return response.data;
    });
}

export const getDelgatedCustomers = (businessIdDelegating:string) => {
    return axios.get(HOST+MODULE+GET_DELEGATED_CUSTOMERS, { params: { businessIdDelegating: businessIdDelegating } })
    .then(response=>{
        return response.data;
    });
}

export const getClientContracts = (businessIdDelegating:string,businessIdDelegated:string) => {
    return axios.get(HOST+MODULE+GET_CLIENT_CONTRACTS,{params:{businessIdDelegating:businessIdDelegating,businessIdDelegated:businessIdDelegated}})
    .then(response=>{
        return response.data;
    });
}

export const postCustomerDelegation = (delegation:ICustomerDelegation,message?:string) => {
    const hasMessage = typeof message === 'string' && message.length > 0;
    const config = hasMessage ? { params: { message } } : undefined;
    return axios.post(HOST+MODULE+CUSTOMER_DELEGATION,delegation ,config)
    .then(response=>{
        return response.data;
    });
}

export const deleteCustomerDelegationAPI = (entityId:string)=>{
    return axios.delete(HOST+MODULE+DELETE_CUSTOMER_DELEGATION,{params:{entityId:entityId}})
    .then(response=>{
        return response.data;
    });
}

export const getDelegationById = (delegationId: string) => {
    return axios.get(HOST + MODULE + GET_DELEGATION_BY_ID, { params: {delegationId: delegationId } });
};

export const postCustomerISCCDocument = (isccDocument:ICustomerIscc,message?:string) => {
    const hasMessage = typeof message === 'string' && message.length > 0;
    const config = hasMessage ? { params: { message } } : undefined;
    return axios.post(HOST+MODULE+POST_CUSTOMER_ISCC_DOCUMENT,isccDocument ,config)
    .then(response=>{
        return response.data;
    });


}

export const putCustomerISCCDocument = (isccDocument:ICustomerIscc,message?:string) => {
    const hasMessage = typeof message === 'string' && message.length > 0;
    const config = hasMessage ? { params: { message } } : undefined;
    return axios.put(HOST+MODULE+POST_CUSTOMER_ISCC_DOCUMENT,isccDocument ,config)
    .then(response=>{
        return response.data;
    });


}


export const getCustomerISCCDocumentById = (entityId:string) => {
    return axios.get(HOST + MODULE + GET_CUSTOMER_ISCC_DOCUMENT_BY_ID, { params: {entityId: entityId } });
}
export const deleteCustomerISCCDocumentAPI = (entityId:string)=>{
    console.log("deleteCustomerISCCDocumentAPI",entityId);
    return axios.delete(HOST+MODULE+DELETE_CUSTOMER_ISCC_DOCUMENT,{params:{entityId:entityId}})
    .then(response=>{
        return response.data;
    });
}

export const putIsccDocumnetStatus = (isccDocument:ICustomerIscc,message?:string) => {
    const hasMessage = typeof message === 'string' && message.length > 0;
    const config = hasMessage ? { params: { message } } : undefined;
    return axios.put(HOST+MODULE+PUT_CUSTOMER_ISCC_DOCUMENT_STATUS,isccDocument ,config)
    .then(response=>{
        return response.data;
    });


}
